import React from 'react';

import { useIntl } from 'react-intl';
import { CSSEditorIsLocked } from '../style';
import { shallowEqual } from 'react-redux';
import { Widget } from 'jamespot-front-business';
import { useAppSelector } from '../../../redux/store';

export const EditorIsLocked = ({ uniqid }: { uniqid: string }) => {
    const intl = useIntl();
    const isLocked = useAppSelector((state) => Widget.selectors.selectWidgetState(state, uniqid), shallowEqual)?.locked;
    return isLocked ? (
        <CSSEditorIsLocked>{intl.formatMessage({ id: 'INTRANET_Panel_Change_Off' })}</CSSEditorIsLocked>
    ) : (
        <></>
    );
};
